export const SUBMISSION_TIMEOUT_MS = 30000;

export const withSubmissionTimeout = (promiseOrFn, timeoutMs = SUBMISSION_TIMEOUT_MS) => {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
        const offlineError = new Error('OFFLINE_ERROR');
        offlineError.code = 'OFFLINE_ERROR';
        return Promise.reject(offlineError);
    }

    let timeoutHandle;
    const promise = typeof promiseOrFn === 'function' ? promiseOrFn() : promiseOrFn;

    const timeoutPromise = new Promise((_, reject) => {
        timeoutHandle = setTimeout(() => {
            const timeoutError = new Error('TIMEOUT_ERROR');
            timeoutError.code = 'TIMEOUT_ERROR';
            timeoutError.isTimeout = true;
            reject(timeoutError);
        }, timeoutMs);
    });

    return Promise.race([promise, timeoutPromise]).finally(() => {
        clearTimeout(timeoutHandle);
    });
};

export const getSubmissionErrorMessage = (
    error,
    defaultMessage = 'Something went wrong while sending your form. Please try again later.'
) => {
    if (
        (typeof navigator !== 'undefined' && !navigator.onLine) ||
        error?.code === 'OFFLINE_ERROR' ||
        error?.message === 'OFFLINE_ERROR'
    ) {
        return 'No internet connection detected. Please check your internet connection and try again.';
    }

    const msg = error?.message || '';
    const lowerMsg = msg.toLowerCase();

    if (
        error?.isTimeout ||
        error?.code === 'TIMEOUT_ERROR' ||
        msg === 'TIMEOUT_ERROR' ||
        error?.code === 'ECONNABORTED' ||
        lowerMsg.includes('timeout') ||
        lowerMsg.includes('timed out')
    ) {
        return 'Request timed out after 30 seconds. Please check your internet connection and try again.';
    }

    if (
        error?.code === 'ERR_NETWORK' ||
        lowerMsg.includes('network error') ||
        lowerMsg.includes('failed to fetch') ||
        lowerMsg.includes('network request failed')
    ) {
        return 'Unable to send form due to an internet connection failure. Please check your network and try again.';
    }

    return defaultMessage;
};
